<template>
  <div>
    <div
      class="modal show fade modal text-left "
      style="display: block;"
      v-if="show && !showDetailsModal"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Register SoftPOS
              <span class="badge badge-light-primary ml-50" v-if="isBulk">{{ targetIds.length }} devices</span>
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card" v-if="!isBulk && row?.thirdparty_references && row.thirdparty_references.length > 0">
              <div class="card-body">
                <div>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Reference</th>
                        <th>Third Party Name</th>
                        <th>Status</th>
                        <th class="text-center">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(ref, index) in row.thirdparty_references" :key="index">
                        <td>
                          <div>{{ ref.reference }}</div>
                          <small class="text-muted" v-if="ref.details?.activationCode">
                            Activation Code: {{ ref.details.activationCode }}
                          </small>
                        </td>
                        <td>{{ ref.thirdparty_config?.thirdparty?.name || '-' }}</td>
                        <td><span class="badge badge-success">Registered</span></td>
                        <td class="text-center">
                          <button
                              type="button"
                              class="btn btn-sm badge btn-primary"
                              v-if="hasDetails(ref)"
                              @click="viewDetails(ref)"
                          >
                            View Details
                          </button>
                          <span v-else>-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Show dropdown if not registered -->
            <div v-else>
              <div class="form-group" v-if="isBulk">
                <label>Selected Devices</label>
                <div>
                  <span class="badge badge-light-primary mr-50 mb-50" v-for="device in rows" :key="device.id">
                    {{ device.name }} ({{ device.device_id }})
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label>Select Third Party</label>
                <div v-if="loading" class="d-flex align-items-center mt-1">
                  <div class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <span class="ml-2">Loading third parties...</span>
                </div>
                <select class="form-control" v-else v-model="selectedThirdParty">
                  <option :value="null">Select Third Party</option>
                  <option v-for="party in thirdParties" :key="party.id" :value="party.id">
                    {{ party.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input
                      type="checkbox"
                      class="custom-control-input"
                      id="sendEmailToMerchant"
                      v-model="sendEmailToMerchant"
                  />
                  <label class="custom-control-label" for="sendEmailToMerchant">
                    Send Email To Merchant
                  </label>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-5">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="registerSoftPos"
                    :disabled="!selectedThirdParty"
                >
                  Register
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show && !showDetailsModal" class="modal-backdrop fade show"></div>
    <TreeModal
        :show="showDetailsModal"
        :treeData="detailModalData"
        :centered="true"
        @hide="showDetailsModal = false"
    ></TreeModal>
  </div>
</template>

<script>
import TreeModal from "@/pages/dashboard/merchant/logs/Tree.vue";

export default {
  components: {
    TreeModal,
  },
  props: ["show", "row", "rows", "storageKey"],
  data() {
    return {
      thirdParties: [],
      selectedThirdParty: null,
      sendEmailToMerchant: false,
      loading: false,
      showDetailsModal: false,
      detailModalData: {},
    };
  },
  computed: {
    /* bulk mode : the modal has been opened from the listing selection */
    isBulk() {
      return Array.isArray(this.rows) && this.rows.length > 0
    },
    targetIds() {
      if (this.isBulk) {
        return this.rows.map(device => device.id)
      }
      return this.row ? [this.row.id] : []
    },
  },
  methods: {
    hasDetails(ref) {
      let details = ref?.details
      return typeof details == "object" && details != null && Object.keys(details).length != 0
    },
    viewDetails(ref) {
      this.detailModalData = ref.details
      this.showDetailsModal = true
    },
    fetchThirdParties() {
      this.loading = true
      this.makeRequest("post", "v1/get-charges-types-data", { 
        thirdParties: 1, 
        alias: 'softpos' 
      },{},false).then(
        callResponse => {
          this.loading = false
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.thirdParties = callResponse.response.data.data?.thirdParties || []
            }
          }
        }
      );
    },
    registerSoftPos() {
      if (!this.selectedThirdParty || !this.targetIds.length) {
        return
      }
      
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/register-softpos", {
        posDeviceIds: this.targetIds,
        thirdpartyId: this.selectedThirdParty,
        sendEmailToMerchant: this.sendEmailToMerchant ? 1 : 0
      }).then(
        callResponse => {
          this.$store.dispatch('exportExcelLoader', false)
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.$emit('hide')
              this.$emit('refresh')
            }
          }
        }
      );
    },
  },
  watch: {
    show(val) {
      if (val && (this.row || this.isBulk)) {
        this.selectedThirdParty = null
        this.sendEmailToMerchant = false
        this.thirdParties = []
        this.showDetailsModal = false
        this.detailModalData = {}
        if (!this.isBulk && this.row.thirdparty_references && this.row.thirdparty_references.length > 0) {
          // Already registered, show table
        } else {
          // Fetch third parties for dropdown
          this.fetchThirdParties()
        }
      }
    }
  }
};
</script>

<style scoped>
.modal{
  display: block !important;
}

.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  max-height: 70vh;
  overflow-y: auto;
}
</style>
